var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sections',{attrs:{"initial-sections":_vm.sections,"require-section":_vm.config.require_section,"add-section-text":_vm.__('Add Set'),"new-section-text":_vm.__('New Set')},on:{"updated":_vm.sectionsUpdated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }